var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('formTextarea',{attrs:{"data":{type: 'text', subtype: 'text', value: _vm.getValue(), label: 'Beschreibung'},"callback":_vm.setDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }